const config = {
    WRITE_KEY_PROD: "RB75Mb7XvsAuJlTznOIY5e98IwA1JdSS",
    WRITE_KEY_STAGING: "BVRlmndQ5RJKFGH0OL602WcW5cdzeHYA",
    VERSION: 1,
}

export default config
